import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import theme from 'theme';

import { LogoIcon } from 'components/icons/LogoIcon';
import ShidoTextIcon from 'components/icons/ShidoTextIcon';

type Props = {
  accountName?: string;
  right?: ReactNode;
  isMobile: boolean;
};

const Header = ({ accountName, right = null, isMobile }: Props) => {
  return (
    <Container $isMobile={isMobile}>
      <Wrapper $center={!accountName && !right}>
        <LogoWrapper>
          <LogoIcon width={63} height={40} fill="white" />
          <ShidoWrapper $isMobile={isMobile}>
            <ShidoTextIcon width={98} height={32} color="white" />
          </ShidoWrapper>
          <TradeMark $logoColor={theme.colors.white} $isMobile={isMobile}>
            ®
          </TradeMark>
        </LogoWrapper>
        {!!accountName && (
          <Text $isMobile={isMobile}>Brought to you by {accountName}</Text>
        )}
        {right && right}
      </Wrapper>
    </Container>
  );
};

const Text = styled.p<{ $isMobile: boolean }>`
  font-size: 16px;
  font-weight: 400;
  line-height: 40px;
  color: ${({ theme }) => theme.colors.white};
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      font-size: 14px;
      font-weight: 300;
      line-height: 26px;
    `}
`;

const TradeMark = styled.span<{ $logoColor: string; $isMobile: boolean }>`
  position: absolute;
  top: 0;
  right: -10px;
  font-size: 12px;
  color: ${({ $logoColor }) => $logoColor};
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      font-size: 16px;
      top: -3px;
      right: -17px;
    `}
`;

const ShidoWrapper = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      display: none;
    `}
`;

const LogoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;

  & > svg {
    width: 46px;
    height: 29px;
  }
`;

const Wrapper = styled.div<{ $center: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  ${({ $center }) =>
    $center &&
    css`
      justify-content: center;
    `}
`;

const Container = styled.header<{ $isMobile: boolean }>`
  background-color: ${({ theme }) => theme.colors.topicBlue};
  display: flex;
  align-items: center;
  padding: 30px 20px;
  border-bottom: 0.25px solid rgb(255 255 255 / 60%);
  box-sizing: border-box;
  z-index: 1000;
  height: 100px;
  filter: drop-shadow(0 20px 40px rgb(0 0 0 / 20%));
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      padding: 21px 20px;
    `}
`;

export default Header;
